import { VStack } from '@bpba/ui-components';
import { ReactNode } from 'react';

/**
 * Espaciado top responsive para la página interna (aire entre el banner y el
 * contenido). Match con el Container de Turnero/Layout.tsx: mt 12px mobile /
 * 24px en >=1280, gap 24px mobile / 32px en >=1280.
 */
export const PageWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <VStack
      mt={['12px', null, null, null, '24px']}
      gap={['24px', null, null, null, '32px']}
      pb={['32px', null, '0px']}
      alignItems="stretch"
      width="100%"
    >
      {children}
    </VStack>
  );
};
